export default "__VITE_ASSET__a0ff3e2e__"